import * as Yup from 'yup';

export const customerValidationSchema = Yup.object().shape({
  name: Yup.string().required('The customer name is required'),
  email: Yup.string()
    .email()
    .required('An email address is required')
});



// WEBPACK FOOTER //
// ./src/validation/customer.js